// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3118":"b7f9c2f15d8ba231","5733":"7903566320a4a7ee"}[chunkId] + ".js";
};